import { VoziqOfferFlow, VoziqOffersChangedEvent } from './voziqOfferFlow.service';

class VoziqOffersBannerController {
    public offerCount = 0;

    constructor(private $scope: ng.IScope, private voziqOfferFlow: VoziqOfferFlow) {
        'ngInject';
    }

    public $onInit() {
        this.loadOffers();
        this.$scope.$on(VoziqOffersChangedEvent, () => this.loadOffers());
    }

    public viewOffers() {
        this.voziqOfferFlow.open('account');
    }

    private loadOffers() {
        this.voziqOfferFlow.getOffers()
            .then((offers) => this.offerCount = offers.length)
            .catch(() => this.offerCount = 0);
    }
}

export const voziqOffersBanner = {
    template: require('./voziqOffersBanner.html'),
    controller: VoziqOffersBannerController
};
